module.exports = __webpack_public_path__ + "img/Group 8.4f558c66.png";